<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-default">
    </base-header>
    <b-container fluid class="mt--7">

    </b-container>
  </div>
</template>
<script>


export default {};
</script>
<style scoped>

</style>
